module.exports = __webpack_public_path__ + "static/media/poster.833fa2d2.png";